import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import { getDataEndPoint, updateDataEndPoint } from "app/utils/constants/paths";
import uuid from "react-uuid";
import { DATASOURCE_CONFIG } from "app/config";
import { addslashes } from "app/utils/utils";
const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  rolesList: [],
  permissionFlag: false,
  permissionsList: [],
  roleDetails: {
    name: "",
    permissions: [],
  },
};

export const GetAllRolesListThunk = createAsyncThunk(
  "role/GetAllRolesListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userId = payload?.authUserData?.user_id;
    let condition = [];
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "ur.name " +
          DATASOURCE_CONFIG.QUERY_LIKE +
          " '%" +
          payload.search +
          "%'"
      );
    }

    if (isSysAdmin != 1) {
      condition.push("ur.created_by='" + userId + "'");
    }

    condition.push("ur.status ='1'");
    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    let query =
      "select ur.id,ur.name,ur.user_permissions,ur.creation_date,(SELECT c.name FROM companies c WHERE c.id = ur.companyid) AS company_name from " +
      tablePrefix +
      "user_roles ur " +
      where +
      " order by ur.creation_date desc";

    const queryBody = {
      queries: [
        {
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const InsertUpdateRoleDetailsThunk = createAsyncThunk(
  "role/InsertUpdateRoleDetailsThunk",
  async (payload) => {
    let insertUpdateQuery = "";
    if (payload.id == "" || payload.id == null || payload.id == undefined) {
      insertUpdateQuery =
        "insert into " +
        tablePrefix +
        "user_roles (id,name,user_permissions,created_by,companyid,creation_date,updated_date) values('" +
        uuid() +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload?.permissions.join(",") +
        "','" +
        payload.created_by +
        "','" +
        payload.companyid +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ")";
    } else {
      insertUpdateQuery =
        "update " +
        tablePrefix +
        "user_roles set name='" +
        addslashes(payload.name) +
        "',user_permissions='" +
        payload?.permissions.join(",") +
        "',updated_date=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        payload.id +
        "'";
    }
    const queryBody = {
      queries: [
        {
          query: insertUpdateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    //console.log("Sidd payload 1", payload);
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetRoleDetailsThunk = createAsyncThunk(
  "role/GetRoleDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,user_permissions from " +
            tablePrefix +
            "user_roles where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetUserPermissionsListThunk = createAsyncThunk(
  "role/GetUserPermissionsListThunk",
  async (payload) => {
    let permissionWhrQry =
      payload?.permissions_arr && payload?.permissions_arr?.length > 0
        ? " and name in('" + payload?.permissions_arr.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "user_permissions where is_deleted=0 and is_test=0 " +
            permissionWhrQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdateUserRoleStatusThunk = createAsyncThunk(
  "role/UpdateUserRoleStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "user_roles set status='0' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const Role = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetRoleForm(state, action) {
      state.roleDetails = {
        name: "",
        permissions: [],
      };
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAllRolesListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllRolesListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.rolesList = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAllRolesListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(InsertUpdateRoleDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateRoleDetailsThunk.fulfilled, (state, action) => {
        if (!action.payload.data?.error) {
          let roleData = {
            name: action.meta.arg.name,
            permissions: action.meta.arg.permissions,
          };
          state.roleDetails = roleData;
        }
        state.loading = false;
      })
      .addCase(InsertUpdateRoleDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetRoleDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetRoleDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results.length > 0) {
          let resultData = action.payload.data?.results[0][0];
          let rolesData = {
            name: resultData.name,
            permissions: resultData.user_permissions.split(","),
          };
          state.roleDetails = rolesData;
        }
        state.loading = false;
      })
      .addCase(GetRoleDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })

      .addCase(GetUserPermissionsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetUserPermissionsListThunk.fulfilled, (state, action) => {
        if (action.payload.data.results[0]) {
          state.permissionsList = action.payload.data.results[0];
          state.permissionFlag = true;
        }
        state.loading = false;
      })
      .addCase(GetUserPermissionsListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateUserRoleStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateUserRoleStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let roleList = state.rolesList;
          let roleId = action.meta.arg.id;
          roleList = roleList.filter((item) => item.id !== roleId);
          state.rolesList = roleList;
        }
        state.loading = false;
      })
      .addCase(UpdateUserRoleStatusThunk.rejected, (state, action) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = Role;
// Extract and export each action creator by name
export const {
  resetRoleForm,
  // showHideSwitchAccountModal,
  // switchToAccount,
  // updateDashboardFilter,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
